export default "/assets/error-2e7c97eee5aaa8cebd28c2ae5cbebe37609c2abb7e0b859abc2f4b194a9a9b2f.svg";